import { Box3, BoxBufferGeometry, Group, Mesh, MeshStandardMaterial, Vector3 } from "three";

export const getGroupSize = (group: Group | Mesh, precise = false) => {
    const size = new Vector3();
    const aabb = new Box3().setFromObject(group, precise);
    aabb.getSize(size);
    return {
        size: size,
        aabb: aabb,
    }
}
export const createBboxMesh = (group: Group | Mesh, precise = false) => {
    const size = getGroupSize(group, precise).size

    const bBoxGeom = new BoxBufferGeometry(size.x, size.y, size.z);
    const bBoxMaterial = new MeshStandardMaterial({ color: "#00FF80", opacity: 0.2, transparent: true });
    return new Mesh(bBoxGeom, bBoxMaterial);
};
